import MONSTRO_7 from "url:../sprites/palhaciano.png";
import SOM_2 from "url:../sfx/ahrah.m4a";

export default {
  attack: 1,
  life: 8,
  speed: 4,
  agility: 6,
  weapon: 3,
  image: MONSTRO_7,
  sound: SOM_2,
};
